import { httpClient } from "@coworker/http-client";
import { ApiEndpoints, BackendServices } from "./EndpointsTypes";

type ResponseType = "json" | "blob" | "text";

export async function postRequest<TBody, TResponse>(
  body: TBody,
  path: ApiEndpoints,
  service: BackendServices,
  responseType?: ResponseType
) {
  return (await internalRequest<TBody, TResponse>(
    body,
    path,
    service,
    "POST",
    responseType
  )) as TResponse;
}

export async function putRequest<TBody, TResponse>(
  body: TBody,
  path: ApiEndpoints,
  service: BackendServices,
  responseType?: ResponseType
) {
  return (await internalRequest<TBody, TResponse>(
    body,
    path,
    service,
    "PUT",
    responseType
  )) as TResponse;
}

async function internalRequest<TBody, TResponse>(
  body: TBody,
  path: ApiEndpoints,
  _service: BackendServices,
  requestType: string,
  responseType?: ResponseType
) {
  return await baseRequest<TBody, TResponse>(
    body,
    path,
    _service,
    requestType,
    responseType
  );
}

async function baseRequest<TBody, TResponse>(
  body: TBody,
  path: ApiEndpoints,
  _service: BackendServices,
  requestType: string,
  responseType?: ResponseType
) {
  if (requestType === "POST") {
    return await httpClient.mfaq.post<TResponse>(`/${path}`, {
      body,
      responseType,
    });
  } else {
    return await httpClient.mfaq.put<TResponse>(`/${path}`, {
      body,
      responseType,
    });
  }
}
